export const GA_TRACKING_ID = "UA-145710862-1";
export const GA4_TRACKING_ID = "G-95RRWMBJ2G";
export const DEVELOPMENT_URL = "http://ruiter.jobhai.team";
export const PRODUCTION_URL = "https://recruiter.jobhai.com";
export const SEEKER_URL = "https://jobhai.com/login";
export const INFOEDGE_URL = "http://infoedge.in/";
export const RECRUITER_ANDROID_APP = "https://nauk.in/gWrDKPjT";
export const PLAY_STORE =
  "https://play.google.com/store/apps/details?id=com.jobhai.recruiter&referrer=utm_source%3Dreferral%26utm_medium%3Dweb%26utm_term%3Drecruiter%26utm_content%3Drating%26utm_campaign%3D";
export const NOT_MENTIONED = "Not Mentioned";
export const NO_DATA = "No Data Available";
export const NEED_HELP_URL = "https://wa.me/918800215527?text=";
export const FEEDBACK =
  "Thank you for the feedback, this will help us improve the experience";
export const INVITED =
  "Thank you! we have updated the candidate, feel free to call them";
export const TO_MANY_ATTEMPT = "Too many attempts, please try after some time";
export const applicationStatus = [
  "VIEWED",
  "SHORTLISTED",
  "REJECTED",
  "SELECTED",
  "HOLD",
  "CALLED"
];
export const gotCandidateList = [
  { value: "Job Hai", label: "Job Hai" },
  { value: "Other Job Portal", label: "Other Job Portal" },
  { value: "Friends", label: "Friends" },
  { value: "Recruitment Agency", label: "Recruitment Agency" }
];
export const distanceFilter = [
  { value: 5, label: "Less than 5 kms" },
  { value: 10, label: "Less than 10 kms" },
  { value: 15, label: "Less than 15 kms" }
];
export const genderFilter = [
  { value: "any", label: "Any" },
  { value: "male", label: "Male" },
  { value: "female", label: "Female" }
];
export const expFilter = [
  { value: "exp-true", label: "Freshers", apiValue: true },
  { value: "exp-false", label: "Experienced", apiValue: false }
];
export const salaryFilter = [
  { value: "0-5000", label: "Less than ₹5000", min: 0, max: 5000 },
  {
    value: "5000-10000",
    label: "Less than ₹10000",
    min: 5000,
    max: 10000
  },
  {
    value: "10000-20000",
    label: "Less than ₹20000",
    min: 10000,
    max: 20000
  },
  {
    value: "20000-30000",
    label: "Less than ₹30000",
    min: 20000,
    max: 30000
  },
  {
    value: "30000-40000",
    label: "Less than ₹40000",
    min: 30000,
    max: 40000
  },
  {
    value: "40000-50000",
    label: "Less than ₹50000",
    min: 40000,
    max: 50000
  }
];
export const resumeFilter = [
  { value: "resume-true", label: "Must have Resume", apiValue: true }
];
export const allfilterList = [
  {
    title: "Distance",
    filterList: distanceFilter,
    panel: "distance",
    isSingleSelect: true
  },
  {
    title: "Experience",
    filterList: expFilter,
    panel: "experience",
    isSingleSelect: true
  },
  {
    title: "Gender",
    filterList: genderFilter,
    panel: "gender",
    isSingleSelect: true
  },
  {
    title: "Resume",
    filterList: resumeFilter,
    panel: "resume",
    isSingleSelect: true
  }
];
export const AUTO_HIDE_DURATION = 6000;

export const ERROR_MESSAGE = "Something went wrong.";
export const ERROR_403_MESSAGE = "Error in validating credentials";
export const ERROR_UNAUTH_MSG = "You are not authorized to make this request";
export const LOGGED_OUT_MSG = "You have been logged-out.";

export const expList = [
  { value: 0, label: "0 month" },
  { value: 6, label: "6 months" },
  { value: 12, label: "1 year" },
  { value: 24, label: "2 years" },
  { value: 36, label: "3 years" },
  { value: 48, label: "4 years" },
  { value: 60, label: "5 years" },
  { value: 72, label: "6 years" },
  { value: 73, label: "6+ years" }
];

export const tempCities = [
  "delhi",
  "faridabad",
  "greater noida",
  "noida",
  "gurgaon",
  "ghaziabad"
];

export const initialGender = {
  label: "Any",
  value: "Any",
  panel: "gender"
};

export const initialJobType = {
  label: "Full Time",
  value: "Full Time",
  panel: "jobType"
};

export const initialWorkingDays = {
  label: "5 days working",
  value: "5 days working",
  panel: "workingDays"
};

export const booleanOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];

export const consultantOptions = [
  { value: false, label: "Your own company" },
  { value: "CONSULTANT", label: "Your client's company" },
  { value: "BOTH", label: "Both" }
];

export const disclaimer =
  "Your account will be blocked & legal action will be taken incase of fraudulent activity";

export const databaseMatchString = "Database Match | Not Applied";

export const widgetH1Count = "45%";
export const widgetH2Count = "4000+";
export const humburgerRecCount = "70%";

export const recruiterShareImg = "/hire/recruiter-share-image.png";

export const postCallFeedbackOptions = [
  {
    label: "Invited for Interview",
    isSelected: false,
    id: "INVITED"
  },
  {
    label: "Call didn't connect",
    isSelected: false,
    id: "Call didn't connect"
  },
  {
    label: "Candidate not relevant",
    isSelected: false,
    id: "CANDIDATE_NOT_RELEVANT"
  },
  {
    label: "Request Call-Back",
    isSelected: false,
    id: "CALLBACK_REQUEST"
  },
  {
    label: "Other",
    isSelected: false,
    id: "other"
  }
];

export const CALL_DIDNT_CONNECT_ID = "Call didn't connect";

export const INVITED_ID = "INVITED";

export const CANDIDATE_NOT_RELEVANT_ID = "CANDIDATE_NOT_RELEVANT";

export const CALLBACK_REQUEST_ID = "CALLBACK_REQUEST";

export const CALLBACK_REQUESTED_ID = "CALLBACK_REQUESTED";

export const OTHER_ID = "other";

export const WHATSAPP_URL = "https://wa.me/";

export const WHATSAPP_WEB_URL = "https://web.whatsapp.com/send";

export const OWN_DRIVING_LICENCE = "Owns Driving License";

export const CONTACT_NO = "18002035244";

export const FORMATED_CONTACT_NO = "1800-203-5244";

export const SALES_CONTACT_NO = "9892900118";

export const REC_JS_WA_COMM_TOOLTIP_END_DATE =
  "Wed Sep 30 2022 12:06:54 GMT+0530 (India Standard Time)";

export const EMPTY_CONTACTED_MESSAGE =
  "Once you call or invite or message candidates, their profiles will be available here";

export const EMPTY_CONTACTED =
  "Once you call or invite candidates, their profiles will be available here";

export const DEFAULT_MAX_LENGTH = 255;

export const STORAGE_ITEMS = {
  recAccessToken: "rec_access_token",
  recruiterSessionId: "recSessionId",
  waRecTrackingId: "waRecTrackingId",
  META_JOB_POST_CACHE: "metaJobPostCache",
  JOB_TITLES_CACHE: "jobTitlesCache",
  JOB_FIELDS_CACHE: "jobFieldsCache",
  CLOSE_REASONS_CACHE: "jobCloseReasonsCache",
  JOB_POST_FIELDS_CACHE: "jobPostFieldsCache",
  JD_METADATA_CACHE: "jdMetadataCache",
  EVENT_TRACKING_DATA_REC: "EVENT_TRACKING_DATA_REC",
  SESSION_ID: "recSessionId"
};

export const STORAGE_KEYS = {
  FILTER_APPLIED: "FILTER_APPLIED",
  SESSION_STORAGE: "SESSION_STORAGE",
  LOCAL_STORAGE: "LOCAL_STORAGE",
  TEMP_EMAIL_DRAWER: "TEMP_EMAIL_DRAWER"
};

export const PERSONAL_EMAILS = [
  "@gmail",
  "@yahoo",
  "@outlook",
  "@rediffmail",
  "@hotmail",
  "@live",
  "@ymail",
  "@icloud",
  "@aol",
  "@msn"
];

export const SESSION_TIME = 30 * 60;
export const DIRECT_APPLIES = "DIRECT_APPLIES";
export const DATABASE_MATCHES = "DATABASE_MATCHES";
export const ALL = "ALL";
export const DATABASE_TAB = "DATABASE_TAB";
export const MOBILE_TYPE = "mobile";

export const ACTIONED = "ACTIONED";
export const UNACTIONED = "UNACTIONED";
export const HIRED = "HIRED";
export const REJECTED = "REJECTED";
export const OTHER = "OTHER";
export const CLOSED = "CLOSED";
export const EXPIRED = "EXPIRED";
export const EMAIL_ALREADY_USED = {
  EMAIL_USED_ALREADY:
    "This email id is already in use. Please try another email id",

  EMAIL_USED_ALREADY_FE: "Email ID is already in use"
};

export const statusBarArray = [
  {
    id: "hired",
    label: "Hired",
    is_selected: false,
    reason: "Hired",
    icon: "/hire/user-star.svg"
  },
  {
    id: "rejected",
    label: "Remove",
    is_selected: false,
    reason: "Removed",
    icon: "/hire/dislike-red.svg"
  },
  {
    id: "other",
    label: "Other",
    is_selected: false,
    reason: "",
    icon: null
  }
];

export const duplicateEditedFields = [
  { label: "Salary", value: "salary" },
  { label: "Experience", value: "experience" },
  { label: "No. of  Openings", value: "no_of_opening" },
  { label: "Something else", value: "something_else" }
];
export const IMAGE_REGEX = /(.*?)\.(pdf|jpg|jpeg|png)$/;
export const PDF_REGEX = /(.*?).(pdf)$/;

export const isProduction = process.env.BASE_URL === "https://api.jobhai.com";
export const tooltipPriorityMap = {
  skilledCandidateTooltip: 5,
  audioTooltip: 2,
  isHiringTooltip: 3,
  cmpJRTip: 4,
  dashboardJRTip: 1,
  lowerEduTooltip: 1,
  otherFieldCommaTooltip: 1,
  creditVisibility: 1
};

export const ProfileAttr = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  EMAIL_ADDRESS: "email",
  PHONE: "mobile",
  AGE: "age",
  FULL_NAME: "userName"
};

export const intentTouchpoint = [
  {
    page: "active",
    touchpoint: "Dashboard-Active"
  },
  {
    page: "review",
    touchpoint: "Dashboard-UnderReview"
  },
  {
    page: ALL,
    touchpoint: "CMP-All"
  },
  {
    page: DIRECT_APPLIES,
    touchpoint: "CMP-Direct-Applies"
  },
  {
    page: DATABASE_MATCHES,
    touchpoint: "CMP-Database-Match"
  },
  {
    page: "job-posting",
    touchpoint: "JobPostingForm"
  }
];

export const addMoreChipObj = [{ value: "other", label: "Add more" }];

export const otherChipObj = [{ value: "other", label: "Other" }];

export const BASIC_JOB = "BASIC";
export const PREMIUM_JOB = "PREMIUM";

export const jobPlanLabelMap = {
  [BASIC_JOB]: "Basic",
  [PREMIUM_JOB]: "Premium"
};

export const TABS = {
  ACTIVE: "active",
  REVIEW: "review",
  CLOSE: "close"
};
export const JOB_STATUS = {
  UNDER_REVIEW: "Job Under Review",
  PAYMENT_PENDING: "Payment Pending",
  DRAFT: "Draft",
  LIVE: "Active Job"
};
export const SUCCESS = "SUCCESS";
export const PENDING = "PENDING";
export const FAILED = "FAILED";
export const DEACTIVATED = "DEACTIVATED";
export const UNDER_REVIEW = "UNDER_REVIEW";
export const CREDITS_ON_HOLD = "CREDITS_ON_HOLD";
export const ALL_TRANSACTIONS = "ALL_TRANSACTIONS";

export const transactionStatusList = [SUCCESS, PENDING, FAILED];

export const transactionHistoryStatusList = [
  SUCCESS,
  PENDING,
  FAILED,
  DEACTIVATED,
  EXPIRED,
  UNDER_REVIEW
];

export const dateFilterList = [
  { label: "Last Month", value: 30 },
  { label: "Last 3 months", value: 90 },
  { label: "Last 6 months", value: 180 },
  { label: "Last 12 months", value: 360 },
  { label: "All", value: 0 }
];

export const transactionStatusMap = {
  PENDING: {
    label: "Pending",
    color: "#B77B33",
    dotColor: "#FFAB00",
    background: "#FFF9EF"
  },
  SUCCESS: {
    label: "Success",
    color: "#037847",
    dotColor: "#14BA6D",
    background: "#ECFDF3"
  },
  FAILED: {
    label: "Failed",
    color: "#C73535",
    dotColor: "#EF5757",
    background: "#FFF0F0"
  },
  DEACTIVATED: {
    label: "De-activated",
    color: "#364254",
    dotColor: "#6C778B",
    background: "#F2F4F7"
  },
  EXPIRED: {
    label: "Expired",
    color: "#364254",
    dotColor: "#6C778B",
    background: "#F2F4F7"
  },
  UNDER_REVIEW: {
    label: "Under Review",
    color: "#B77B33",
    dotColor: "#FFAB00",
    background: "#FFF9EF"
  }
};

export const transactionLabelMap = {
  "Credits Purchase": ["orderId", "amount"],
  "Credits Received": ["receivedFrom", "actionBy"],
  "Balance Adjustment": [],
  "Credits Consumed": [
    "jobId",
    "numberOfCandidatesDownloaded",
    "numberOfCandidatesUnlocked",
    "requisitionId"
  ],
  "Credits Expired": [],
  "Credits Sent": ["sentTo", "actionBy"],
  "Service de-activated": [],
  "Paid Credit Addition on CRM": ["orderId", "amount"],
  "Candidate Download": ["jobId", "numberOfCandidates", "requisitionId"]
};

export const transactionKeyLabelMap = {
  orderId: "Order ID",
  amount: "Amount",
  receivedFrom: "Received from",
  jobId: "Premium Job ID",
  sentTo: "Sent to",
  actionBy: "By",
  numberOfCandidates: "Number of Candidates",
  numberOfCandidatesDownloaded: "Candidates downloaded",
  numberOfCandidatesUnlocked: "Candidates unlocked",
  requisitionId: "Search ID"
};

export const transactionKeyLabelMapDesktop = {
  orderId: "Order ID: ",
  amount: "",
  receivedFrom: "From ",
  jobId: "Premium Job ID: ",
  sentTo: "To ",
  actionBy: "By ",
  boostedJobId: "Boosted Job ID: ",
  numberOfCandidates: "Number of Candidates: ",
  numberOfCandidatesDownloaded: "Candidates downloaded: ",
  numberOfCandidatesUnlocked: "Candidates unlocked: ",
  requisitionId: "Search ID: "
};

export const CREDIT_VISIBILITY_COUNT = 5;
export const DAILY_CREDIT_EXPIRE_TIME = 1;

export const jobPremiumBenefits = [
  "Boosted job visibility",
  "High number of direct applies",
  "High number of database matches",
  "Highlighted with an urgent hiring tag"
  // "Get 1 job boost"
];

export const COMPANY_DEBOUNCE_TIME = 50;

export const QUALIFICATIONS_OBJ = {
  Any: 1,
  "10th Pass": 2,
  "12th Pass": 3,
  Diploma: 4,
  Graduate: 5,
  "Post Graduate": 6
};
export const premiumPopupsTypes = {
  upgradeJob: "UPGRADE_JOB",
  postPremiumJob: "POST_PREMIUM_JOB",
  // V2 types for new system
  upgradeJobV2: "UPGRADE_JOB_V2",
  postPremiumJobV2: "POST_PREMIUM_JOB_V2"
};

export const modalStateValues = {
  open: "OPEN",
  CLOSE: "CLOSE"
};

export const DB_EDUCATION_SHOWN_COUNT = "dbEducationShownCount";

export const DB_EDUCATION_LAST_SHOWN = "dbEducationLastShown";

export const JOB_POST_RESET_CLICKED = {
  name: "JOB_POST_RESET_CLICKED",
  category: "JOB"
};

export const modalType = {
  VIDEO_MODAL_BACKDROP: "videoContainerBackDrop",
  INVOICE_EMAIL_MODAL: "invoiceEmailModal",
  EDIT_PROFILE: "editProfile",
  EDIT_COMPANY: "editCompany",
  PHONE_VERIFICATION: "phoneVerification",
  COMPANY_NAME_CHANGE_DOC_UPLOAD: "companyNameChangeDocUpload",
  DOCUMENT_VIEWER: "documentViewer",
  DEACTIVATION_MODAL: "deactivationModal",
  DEACTIVATION_OTP_VERIFICATION: "deactivationOtpVerification",
  COMPANY_NAME_CHANGE_SELECT: "companyNameChangeSelect",
  EDIT_COMPANY_DETAILS: "editCompanyDetails",
  TEAM_EXIT_MODAL: "teamExitModal",
  CATEGORY_CHANGE_ALERT: "categoryChangeAlert",
  BLACKLISTED_REC_JOB_POST_POP_UP_V2: "blacklistedRecJobPostPopUpV2",
  RESTRICTING_FRAUDULENT: "restrictingFraudulent",
  REMOVE_CANDIDATE_MODAL: "removeCandidateModal",
  TOOLTIP_MODAL: "tooltipModal",
  JOB_BOOST_YET_TO_START: "jobBoostYetToStart",
  CANDIDATE_PREVIEW: "candidatePreview",
  PRE_SCREENING_ANSWERS: "preScreeningAnswers",
  TAB_CHANGE_WARNING: "tabChangeWarning",
  CMP_V3_GTM: "CMPV3GTM",
  TEAM_REQUEST_REJECTION_MODAL: "teamRequestRejectionModal",
  BULK_WHATSAPP_JOBS_MODAL: "bulkWhatsAppJobsModal"
};

export const zustandFetchStates = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  IDLE: "IDLE"
};

export const TEAM_JOINING_STATUS = {
  FAILED: "FAILED",
  SUCCESS: "SUCCESS",
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS"
};

export const USER_TYPE = {
  RECRUITER: "RECRUITER",
  ADMIN: "ADMIN",
  SUB_USER: "BASIC"
};
export const GST_POLLING_MAX_TRIES = 6;
export const GST_POLLING_INTERVAL = 3000;
export const FREE_UNLOCK_COOKIE_KEY = "jh_hide_free_unlock_popup";
export const PAID_UNLOCK_COOKIE_KEY = "jh_hide_paid_unlock_popup";
export const BULK_UNLOCK_SUGGESTION_COOKIE_KEY =
  "jh_hide_bulk_unlock_suggestion_popup";
export const BULK_UNLOCK_DISCLAIMER_COOKIE_KEY =
  "jh_hide_bulk_unlock_disclaimer_popup";
export const CMP_EDU_CTA_COOKIE_KEY = "cmp_edu_cta_dismissed";

export const MIN_UNLOCK_TO_SHOW_EDUCATION_TAGS = 10;

// Facebook Pixel Configuration
export const FB_PIXEL_ID = "3230052927008993";
export const LINE_CHART_TICK_INTERVALS = {
  MOBILE: 5,
  DESKTOP: 4
};

export const SOURCE_RECOMMENDED = "reco";
